import { Box, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

export const CheckedImageWrapper = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(183, 209, 255, 0.50);
  align-items: center;
  justify-content: center;
`;

export const TitleContainer = styled(Box)`
  container-type: inline-size;
  width: 100%;
  padding: ${({ theme }) => theme.spacings.xxs};
`;

export const Title = styled(Text)`
  /* fallback */
  font-size: 32px;

  font-size: clamp(10px, 8cqw, 32px);
  text-align: center;
  font-weight: 700;
`;
